import axiosInstance from "../Shared/Utils/axiosInstance";
import {
  getAddRequestBody,
  getUpdateRequestBody,
} from "./MasterServiceRequests";
import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
import { errorToastStyle, successToastStyle } from "../Shared/Utils/ToastUtils";
import { toast } from "react-toastify";
import UserRoles from "../Shared/Constant/UserRoles";
import masterApiErrorMessageEng from "../Shared/Constant/MasterTranslation/MasterApiErrorMessageEng.json";
import MasterTypes from "../Shared/Constant/MastersTypes";
const somethingWentWrong = "Something went wrong!!!";

const getErrorMessage = (t, error, alternateMessage = "") => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message &&
    masterApiErrorMessageEng[error.response.data.message]
  ) {
    return t(error.response.data.message);
  }
  return alternateMessage;
};
const handelAssosiateErrorMessage = (t, masterType, selectedName) => {
  switch (masterType) {
    case MasterTypes.DISTRICT:
      return `${selectedName} ${t(
        "is associated with one or more talukas. Please remove associated talukas"
      )}`;
    case MasterTypes.TALUKA:
      return `${selectedName} ${t(
        "is associated with one or more PHCs. Please remove associated PHCs"
      )}`;
    case MasterTypes.PHC:
      return `${selectedName} ${t(
        "is associated with one or more subcenters. Please remove associated subcenters"
      )}`;
    case MasterTypes.SUBCENTER:
      return `${selectedName} ${t(
        "is associated with one or more villages. Please remove associated villages"
      )}`;
    case MasterTypes.ROLE:
      return `${selectedName} ${t(
        "is associated with one or more users. Please remove associated users"
      )}`;
    case MasterTypes.TRAINING:
    case MasterTypes.FACULTY:
      return `${selectedName} ${t(
        "is associated with one or more training calendars. Please remove associated training calendars"
      )}`;
    case MasterTypes.PROGRAM:
      return `${selectedName} ${t(
        "is associated with one or more schemes. Please remove associated schemes"
      )}`;
    case MasterTypes.SCHEME:
      return `${selectedName} ${t(
        "is associated with one or more activities. Please remove associated activities"
      )}`;
    default:
      return t("Something went wrong!!!");
  }
};
const getErrorMessageDelete = (
  t,
  error,
  masterType,
  selectedName,
  alternateMessage = ""
) => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message &&
    masterApiErrorMessageEng[error.response.data.message]
  ) {
    if (error.response.data.message === "Can not delete it has associated") {
      handelAssosiateErrorMessage(t, masterType, selectedName);
    } else {
      return t(error.response.data.message);
    }
  }
  return alternateMessage;
};
console.log("getErrorMessageDelete",getErrorMessageDelete);

const masterDataMapping = (data) => {
  return (data || []).map((d) => {
    if (d.startDate && !(d.startDate instanceof Date)) {
      const dateOnly =
        d && d.startDate ? d.startDate.toString().split(" - ") : [];
      if (dateOnly.length > 1) {
        const date = new Date(dateOnly[0]);
        d.startDate = date;
      }
    }

    if (!(d.recModifiedDate instanceof Date)) {
      const dateOnly =
        d && d.recModifiedDate ? d.recModifiedDate.toString().split(" - ") : [];
      if (dateOnly.length > 1) {
        const date = new Date(dateOnly[0]);
        const time = dateOnly[1];
        d.recModifiedDate = date;
        d.time = time;
        return d;
      }
    }
    d.recModifiedDate = "";
    d.time = "";
    return d;
  });
};

// http://localhost:5000/masterRouter/getData?masterName=districtMaster
// http://localhost:5000/masterRouter/addData?masterName=districtMaster
// http://localhost:5000/masterRouter/updateData?masterName=districtMaster
// http://localhost:5000/masterRouter/deleteData/1?masterName=districtMaster

/** masterType is masterName in query params */

export const getMasterDataServiceById = async (id, masterType) => {
  try {
    const apiUrl = `/api/initialValue?id=${id}&masterName=${masterType}`;
    const response = await axiosInstance.get(apiUrl);
    if (response.status === 200 && response.data && response.data.data) {
      return TokenDecrypt(response.data.data);
    }
    throw new Error("Master data get failed!!!");
  } catch (error) {
    throw new Error(error.message || somethingWentWrong);
  }
};

export const getMasterDataService = async (
  masterType,
  languageId,
  page = 1,
  pageSize = 10,
  filters 
) => {
  try {
    let languageIdParam = languageId === 2 ? 2 : 1;
    let apiUrl = `/masterRouter/getData/${languageIdParam}?masterName=${masterType}&page=${page}&pageSize=${pageSize}`;
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (value instanceof Date) {
          const formattedDate = value.toISOString().split("T")[0]; 
          apiUrl += `&${key}=${encodeURIComponent(formattedDate)}`;
        } else {
          apiUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      }
    });
    const response = await axiosInstance.get(apiUrl);
    if (response.status === 200 && response.data && response.data.data) {
      const decryptData = TokenDecrypt(response.data.data)
      return { data: masterDataMapping(decryptData?.data), totalCount: decryptData?.totalCount, page: decryptData?.page
        ,pageSize: decryptData?.pageSize}
    }
    throw new Error("Master data get failed!!!");
  } catch (error) {
    throw new Error(error.message || somethingWentWrong);
  }
};

const showAddSuccessMessage = (title, t) => {
  const currentUserRole = sessionStorage.getItem("userRole"); // Use getItem instead of get
  if (UserRoles.ADMIN === currentUserRole) {
    toast.success(
      `${t(title)} ${t(
        "Master Added Successfully & Sent for approval to Super Admin!"
      )}`,
      {
        style: successToastStyle,
      }
    );
  } else {
    toast.success(`${t(title)} ${t("Master Added Successfully!")}`, {
      style: successToastStyle,
    });
  }
};

export const addMastersDataService = async (masterType, title, data, t) => {
  try {
    const postConfig = {
      headers: {
        "content-type": Array.isArray(data)
          ? "application/json"
          : "multipart/form-data",
      },
      url: `/masterRouter/addData?masterName=${masterType}`,
      data: getAddRequestBody(masterType, data),
      method: "POST",
    };
    const response = await axiosInstance(postConfig);
    showAddSuccessMessage(title, t); 
    return response.data;
  } catch (error) {

    const errorMessage =
      error.response?.data?.message ||
      getErrorMessage(
        t,
        error,
        `${t("Failed to add")} ${t(title)} ${t("Master!")}`
      );

    toast.error(errorMessage, {
      style: errorToastStyle,
    });

    throw new Error(errorMessage || "Something went wrong");
  }
};

export const updateMastersDataService = async (masterType, title, data, t) => {
  try {
    const putConfig = {
      headers: {
        "content-type": Array.isArray(data)
          ? "application/json"
          : "multipart/form-data",
      },
      url: `/masterRouter/updateData?masterName=${masterType}`,
      data: getUpdateRequestBody(masterType, data),
      method: "PUT",
    };
    const response = await axiosInstance(putConfig);
    toast.success(`${t(title)} ${t("Master Updated Successfully!")}`, {
      style: successToastStyle,
    });
    return response.data;
  } catch (error) {
    toast.error(
      getErrorMessage(
        t,
        error,
        `${t("Failed to update")} ${t(title)} ${t("Master!")}`
      ),
      {
        style: errorToastStyle,
      }
    );
    throw new Error(error.message || somethingWentWrong);
  }
};

export const deleteMasterDataService = async (
  masterType,
  title,
  selectedId,
  selectedName,
  t
) => {
  try {
    const response = await axiosInstance.delete(
      `/masterRouter/deleteData/${selectedId}?masterName=${masterType}`
    );
    if (response.status === 200) {
      toast.success(
        `${t(selectedName)} ${t(title)} ${t("Deleted Successfully!")}`,
        {
          style: successToastStyle,
        }
      );
      return response.data;
    } else {
      toast.error(
        `${t(selectedName)} ${t(title)} - ${t(response.message)}`,
        {
          style: errorToastStyle,
        }
      );
      throw new Error(response.data.data.message);
    }
  } catch (error) {
    // Extract the backend error message or use a fallback message
    const backendMessage =
      error.response?.data?.message || `${t("Failed to Delete")}`;
    toast.error(
      `${t(selectedName)} ${t(title)} - ${t(backendMessage)}`,
      {
        style: errorToastStyle,
      }
    );
    throw new Error(backendMessage);
  }
};

export const getMasterCardsDataService = async () => {
  try {
    const url = `/allMaster/getAllMasters`;
    const response = await axiosInstance.get(url);
    if (response.status === 200 && response.data && response.data.data) {
      return TokenDecrypt(response.data.data);
    }
    throw new Error("Failed to card masters");
  } catch (error) {
    throw new Error(error.message || somethingWentWrong);
  }
};
